import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { urls } from 'helpers/url';
import { navigate } from 'actionCreators';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import PhaseType from 'types/phase';
import TaskType from 'types/task';

export class RescheduleWorkorder extends PhaseTask {
  isDisabled = () => false

  onClick = () => (this.props.task.status !== 'complete' ?
    this.props.navigate(urls.phaseAppointments(this.props.phase)) :
    this.toggleStatus());
}

RescheduleWorkorder.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

export const reschedule_workorder = connect(() => state => ({
  user: state.user,
}), { updatePhaseTask, navigate })(RescheduleWorkorder);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/reschedule_workorder.jsx